import React from 'react';

const Button = ({ children, variant = 'primary', onClick, className = '' }) => {
  const baseStyles = 'px-6 py-3 rounded-lg font-medium transition-colors duration-200';
  const variants = {
    primary: 'bg-[#0d9488] text-white hover:bg-[#0d9488]/90',
    secondary: 'border-2 border-[#0d9488] text-[#0d9488] hover:bg-[#0d9488]/10',
    white: 'bg-white text-[#0d9488] hover:bg-gray-50'
  };

  return (
    <button 
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;